<template>
  <div>
    <b-button variant="success" @click="showModal('modal-createstoresaleswithtemplate')">Umsätze nach Vorlage anlegen</b-button>
                        

    <b-modal ref="modal-createstoresaleswithtemplate"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Umsätze nach Vorlage anlegen" @cancel="hideModal('modal-createstoresaleswithtemplate')" @ok="openStoreSaleTemplateGroupModal" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-cols="4" label-cols-lg="2" label="Vorlage" label-for="cswt1">
                    <b-form-select id = "css1" v-model="storeSalesTemplateGroupId">
                         <option v-for="option in storeSalesTemplateGroupMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Datum von" label-for="cswt2">
                    <b-form-input id="cswt2" v-model="templateCreationStartDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Datum bis" label-for="cswt3">
                    <b-form-input id="cswt3" v-model="templateCreationEndDate" type="date"></b-form-input>
                </b-form-group>

               
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen der Umsätze.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-viewstoresalestemplategroup"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Umsatz Vorlage Detail" @cancel="hideModal('modal-viewstoresalestemplategroup')" @ok="createStoreSalesWithTemplate" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Umsatz Muster">
                    <b-row class="my-1">
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createstoresalestemplate')">Umsatz Muster hinzufügen</b-button>
                        </b-col>
                    </b-row>
                    <div v-if="storeSalesTemplates!= undefined">
                        <b-table bordered :items="storeSalesTemplates" :fields="storeSalesTemplateFields">
                            <template slot="amount" slot-scope="row">
                                {{row.item.amount/100}}
                                
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-button class="mx-1" size="sm" v-on:click="openStoreSaleTemplateViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                                <b-button class="mx-1" size="sm" v-on:click="openStoreSaleTemplateEditModal(row.item.id)"><i class="fas fa-pencil-alt"></i></b-button>
                                <b-button class="mx-1" size="sm" variant="danger" v-on:click="deleteStoreSaleTemplate(row.item.id)"><i class="fas fa-trash"></i></b-button>
                            </template>
                        
                        </b-table>
                    </div>
                    
                </b-tab>
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-viewstoresalestemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Umsatz Detail" @cancel="hideModal('modal-viewstoresalestemplate')" @ok="hideModal('modal-viewstoresalestemplate')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Vorlage" active>
                    <div v-if="storeSalesTemplateMap[storeSalesTemplateId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Wochentage:</b> 
                            </b-col>
                            <b-col>
                                <p >{{storeSalesTemplateMap[storeSalesTemplateId].weekDays}} </P>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Von:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].from}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Bis:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].to}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Betrag:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].amount}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Währung:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].currency}}
                            </b-col>
                        </b-row>
                         <b-row>
                            <b-col class="md-2">
                                <b>Stückzahl:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].itemCount}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Gästezahl</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].guestCount}}
                            </b-col>
                        </b-row>
                        <b-row>
                            
                            <b-col class="md-2">
                                <b>Beschreibung:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].description}}
                            </b-col>
                        </b-row>
                    </div>
                </b-tab>
                

            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-createstoresalestemplate"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Umsatz anlegen" @cancel="hideModal('modal-createstoresalestemplate')" @ok="createStoreSaleTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Umsatz" label-for="css1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSalesTemplate.amount" step="0.01" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Stückzahl" label-for="css1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSalesTemplate.itemCount" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Gästezahl" label-for="css1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSalesTemplate.guestCount" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Währung" label-for="css2">
                    <b-form-select id = "css2" v-model="storeSalesTemplate.currency">
                        <option v-bind:key ="1" v-bind:value="'EUR'">
                            EUR
                        </option>
                        <option v-bind:key ="2" v-bind:value="'USD'">
                            USD
                        </option>
                        <option v-bind:key ="3" v-bind:value="'GBP'">
                            GBP
                        </option>
                        <option v-bind:key ="4" v-bind:value="'CHF'">
                            CHF
                        </option>
                        <option v-bind:key ="5" v-bind:value="'CZK'">
                            CZK
                        </option>
                        <option v-bind:key ="6" v-bind:value="'JPY'">
                            JPY
                        </option>
                        <option v-bind:key ="7" v-bind:value="'CNY'">
                            CNY
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Uhrzeit von" label-for="cst2">
                    <b-form-input id="cst2" v-model="storeSalesTemplate.from" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Uhrzeit bis" label-for="cst3">
                    <b-form-input id="cst3" v-model="storeSalesTemplate.to" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Montag" label-for="mondaycheck">
                     <b-form-checkbox id="mondaycheck" v-model="storeSalesTemplate.monday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Dienstag" label-for="tuesdaycheck">
                     <b-form-checkbox id="tuesdaycheck" v-model="storeSalesTemplate.tuesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Mittwoch" label-for="wednesdaycheck">
                     <b-form-checkbox id="wednesdaycheck" v-model="storeSalesTemplate.wednesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Donnerstag" label-for="thursdaycheck">
                     <b-form-checkbox id="thursdaycheck" v-model="storeSalesTemplate.thursday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Freitag" label-for="fridaycheck">
                     <b-form-checkbox id="fridaycheck" v-model="storeSalesTemplate.friday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Samstag" label-for="saturdaycheck">
                     <b-form-checkbox id="saturdaycheck" v-model="storeSalesTemplate.saturday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Sonntag" label-for="sundaycheck">
                     <b-form-checkbox id="sundaycheck" v-model="storeSalesTemplate.sunday">
                    </b-form-checkbox>
                </b-form-group>

                 <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Beschreibung" label-for="cst9">
                    <b-form-input id="cst9" v-model="storeSalesTemplate.description" type="text"></b-form-input>
                </b-form-group>
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen des Muster Umsatzes.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-editstoresalestemplate"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Umsatz bearbeiten" @cancel="hideModal('modal-editstoresalestemplate')" @ok="updateStoreSaleTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div v-if="storeSalesTemplateMap[storeSalesTemplateId]!=undefined">
            
               
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Umsatz" label-for="css1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSalesTemplateMap[storeSalesTemplateId].amount" step="0.01" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Stückzahl" label-for="css1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSalesTemplateMap[storeSalesTemplateId].itemCount" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Gästezahl" label-for="css1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSalesTemplateMap[storeSalesTemplateId].guestCount" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Währung" label-for="css2">
                    <b-form-select id = "css2" v-model="storeSalesTemplateMap[storeSalesTemplateId].currency">
                        <option v-bind:key ="1" v-bind:value="'EUR'">
                            EUR
                        </option>
                        <option v-bind:key ="2" v-bind:value="'USD'">
                            USD
                        </option>
                        <option v-bind:key ="3" v-bind:value="'GBP'">
                            GBP
                        </option>
                        <option v-bind:key ="4" v-bind:value="'CHF'">
                            CHF
                        </option>
                        <option v-bind:key ="5" v-bind:value="'CZK'">
                            CZK
                        </option>
                        <option v-bind:key ="6" v-bind:value="'JPY'">
                            JPY
                        </option>
                        <option v-bind:key ="7" v-bind:value="'CNY'">
                            CNY
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Uhrzeit von" label-for="ust2">
                    <b-form-input id="ust2" v-model="storeSalesTemplateMap[storeSalesTemplateId].from" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Uhrzeit bis" label-for="cst3">
                    <b-form-input id="ust3" v-model="storeSalesTemplateMap[storeSalesTemplateId].to" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Montag" label-for="umondaycheck">
                     <b-form-checkbox id="umondaycheck" v-model="storeSalesTemplateMap[storeSalesTemplateId].monday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Dienstag" label-for="utuesdaycheck">
                     <b-form-checkbox id="utuesdaycheck" v-model="storeSalesTemplateMap[storeSalesTemplateId].tuesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Mittwoch" label-for="uwednesdaycheck">
                     <b-form-checkbox id="uwednesdaycheck" v-model="storeSalesTemplateMap[storeSalesTemplateId].wednesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Donnerstag" label-for="uthursdaycheck">
                     <b-form-checkbox id="uthursdaycheck" v-model="storeSalesTemplateMap[storeSalesTemplateId].thursday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Freitag" label-for="ufridaycheck">
                     <b-form-checkbox id="ufridaycheck" v-model="storeSalesTemplateMap[storeSalesTemplateId].friday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Samstag" label-for="usaturdaycheck">
                     <b-form-checkbox id="usaturdaycheck" v-model="storeSalesTemplateMap[storeSalesTemplateId].saturday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Sonntag" label-for="usundaycheck">
                     <b-form-checkbox id="usundaycheck" v-model="storeSalesTemplateMap[storeSalesTemplateId].sunday">
                    </b-form-checkbox>
                </b-form-group>

                 <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Beschreibung" label-for="ust9">
                    <b-form-input id="ust9" v-model="storeSalesTemplateMap[storeSalesTemplateId].description" type="text"></b-form-input>
                </b-form-group>
            </div>
            
            <b-row v-if="error">
                Fehler beim Update der Muster Umsatz.
            </b-row>
        </b-container>
    </b-modal>

    
</div>

</template>

<script>
export default {
  name: 'storesalecreationwithtemplate',
  data () {
    return {
     
        storeSalesTemplateGroupMap: {},
        storeSalesTemplateGroupId: null,
        templateCreationStartDate: null,
        templateCreationEndDate: null,
        storeSalesTemplateMap: {},
        storeSalesTemplates: [],
      
        storeSalesTemplateFields: [{key:"from", label:"Von", sortable: true},{key:"to", label:"Bis", sortable: true},
                           {key:"amount", label:"Betrag", sortable: true}, {key:"currency", label:"Währung", sortable: true}, {key:"weekDays", label:"Wochentage", sortable: false},{key:"actions", sortable: false}],
        storeSalesTemplateId: "",
        storeSalesTemplate: {
         
            from: null,
            to: null,
            amount: 0,
            currency: "EUR",
            monday: false,
            tuesday: false,
            wednesday:false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
            guestCount: 0,
            itemCount: 0,
            planned: true,
            description: ""
          
        },
      
        error: false,
      
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
         this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;
        
        

        this.loadStoreSaleTemplateGroups()
        .then(response => {
            view.updateStoreSaleTemplateGroups(response.data);
        }).catch(function (error) {
            console.log(error)
        })


       
    }, 
    openStoreSaleTemplateGroupModal: function() {
        let view = this;
        view.hideModal("modal-createstoresaleswithtemplate");
        this.loadStoreSaleTemplates(this.storeSalesTemplateGroupId)
        .then(response => {
            let templateIds = [];
            for(let i = 0; i < response.data.length; i++){
                templateIds.push(response.data[i].id);
            }
            view.updateStoreSaleTemplates(response.data);
            view.showModal("modal-viewstoresalestemplategroup");
            
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })
    },
    openStoreSaleTemplateViewModal: function(id){
        
        this.storeSalesTemplateId = id;
        
        this.showModal('modal-viewstoresalestemplate');   
        
    },
    openStoreSaleTemplateEditModal: function(id){
        
        this.storeSalesTemplateId = id;
        let template = this.storeSalesTemplateMap[this.storeSalesTemplateId];
       
        template.amount = this.storeSalesTemplateMap[this.storeSalesTemplateId].amount/100;
        
        if(template.weekDays.includes(1)){
            template.monday = true;
        }
        if(template.weekDays.includes(2)){
           template.tuesday = true;
        }
        if(template.weekDays.includes(3)){
           template.wednesday = true;
        }
        if(template.weekDays.includes(4)){
            template.thursday = true;
        }
        if(template.weekDays.includes(5)){
           template.friday = true;
        }
        if(template.weekDays.includes(6)){
           template.saturday = true;
        }
        if(template.weekDays.includes(7)){
            template.sunday = true;
        }

        
        this.showModal('modal-editstoresalestemplate');
    },
    createStoreSaleTemplate: function(evt){
       
        let template = {
          id: this.generateUUID(),
          groupId: this.storeSalesTemplateGroupId,
          from: this.storeSalesTemplate.from,
          to: this.storeSalesTemplate.to,
          amount: Math.floor(this.storeSalesTemplate.amount*100),
          currency: this.storeSalesTemplate.currency,
          itemCount: this.storeSalesTemplate.itemCount,
          guestCount: this.storeSalesTemplate.guestCount,
          planned: true,
          description: this.storeSalesTemplate.description,
          
          weekDays: [],
        }
        if(this.storeSalesTemplate.monday){
            template.weekDays.push(1);
        }
        if(this.storeSalesTemplate.tuesday){
            template.weekDays.push(2);
        }
        if(this.storeSalesTemplate.wednesday){
            template.weekDays.push(3);
        }
        if(this.storeSalesTemplate.thursday){
            template.weekDays.push(4);
        }
        if(this.storeSalesTemplate.friday){
            template.weekDays.push(5);
        }
        if(this.storeSalesTemplate.saturday){
            template.weekDays.push(6);
        }
        if(this.storeSalesTemplate.sunday){
            template.weekDays.push(7);
        }
       
        

        let storeSalesTemplateItem = {
            id: template.id,
            from: template.from,
            to: template.to,
            amount: template.amount,
            currency: template.currency,
            weekDays: template.weekDays
        }
            
        
        this.storeSalesTemplateMap[template.id] = template;
        this.storeSalesTemplates.push(storeSalesTemplateItem); 
    },
    
    updateStoreSaleTemplate: function(evt){
        

        let template = this.storeSalesTemplateMap[this.storeSalesTemplateId];
        template.weekDays = [];
        if(template.monday){
            template.weekDays.push(1);
        }
        if(template.tuesday){
           template.weekDays.push(2);
        }
        if(template.wednesday){
            template.weekDays.push(3);
        }
        if(template.thursday){
            template.weekDays.push(4);
        }
        if(template.friday){
            template.weekDays.push(5);
        }
        if(template.saturday){
           template.weekDays.push(6);
        }
        if(template.sunday){
            template.weekDays.push(7);
        }

        if(template.calculateWorkvalue){
            template.workValue = -1;
        }

        template.amount = Math.floor(template.amount*100);

        const index = this.storeSalesTemplates.findIndex(storesalestemplate => storesalestemplate.id === template.id) 
        if (~index) {
            this.storeSalesTemplates[index].from = template.from;
            this.storeSalesTemplates[index].to = template.to;
            this.storeSalesTemplates[index].amount = template.amount;
            this.storeSalesTemplates[index].currency = template.currency;
            this.storeSalesTemplates[index].weekDays = template.weekDays;
            
        }
    },
    createStoreSalesWithTemplate: function() {
        let view = this;
        let dayMap = {};
        let day;

        for(let templateId in this.storeSalesTemplateMap){

            let template = this.storeSalesTemplateMap[templateId];
            
            for(let j = 0; j< template.weekDays.length; j++){
                day = template.weekDays[j];
                //convert 1-7 day to 0-6 JS day
                 if(day === 7){
                    day = 0
                }
                if(dayMap[day] === undefined){
                       dayMap[day] = [];
                }
                dayMap[day].push(template.id);
             }
        }

        let startDate = new Date(this.templateCreationStartDate);
        let endDate = new Date(this.templateCreationEndDate);

        let storeSalesRequests = [];
        let template;
            
        while(this.getMinuteDiffAbs(startDate, endDate) > 0){
           
                for(let templateId in this.storeSalesTemplateMap){
                    let template = this.storeSalesTemplateMap[templateId];
                    let split = template.from.split(':');
                    let from = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate(), split[0], split[1]));
                    
                    split = template.to.split(':');
                    let to = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate(), split[0], split[1]));
                    //console.log(this.getMinuteDiff(from, to));
                    if(this.getMinuteDiff(from, to) < 0){
                        to.setUTCHours(to.getUTCHours()+24);
                    }
                    
                    from = this.$helpers.convertDateTimeString(this.$helpers.extractDateString(from.toString()), template.from);
                    to = this.$helpers.convertDateTimeString(this.$helpers.extractDateString(to.toString()), template.to);
                    
                    let alreadyCreated = false;
                    
                    let day = startDate.getDay();
                    if(day === 0){
                        day = 7;
                    }
                    if(template.weekDays.includes(day)){
                        let request = {
                            from: from,
                            to: to,
                            amount: template.amount,
                            currency: template.currency, 
                            itemCount: template.itemCount,
                            guestCount: template.guestCount,
                            description: template.description,
                            planned: true,
                            templateId: template.id
                        }
                        alreadyCreated = true;
                        storeSalesRequests.push(request);
                        
                    }

                    
                    
                }
                
            
            
            startDate.setUTCHours(startDate.getUTCHours() + 24);
        }
        if(storeSalesRequests.length > 0){
            let url = '/api/sec/storesales/multi';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales/multi');

            let payload = {
                requests: storeSalesRequests
            }
                
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {

                
                view.error = false;
                view.$emit("refreshStoreSales");
                view.hideModal('modal-viewstoresalestemplategroup')

               
            }).catch(function (error) {
                view.error=true;
                console.log(error)
            })
        } else {
            view.hideModal('modal-viewstoresalestemplategroup')
        }
        
    },
   
    loadStoreSaleTemplateGroups : function() {
     
        let url = '/api/sec/salestemplategroup';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplategroup');
 
        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })
			
    },
    updateStoreSaleTemplateGroups : function(data){
        let groupMap = {};
        for (let i = 0; i < data.length; i++) {
            
            groupMap[data[i].id] = data[i];     
        }
        this.storeSalesTemplateGroupMap = groupMap;
    },
    loadStoreSaleTemplates : function(id) {
      
      let url = '/api/sec/salestemplate';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplate');
      url = this.$helpers.appendParam("groupId", id, url, '/api/sec/storesalestemplate')

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    updateStoreSaleTemplates : function(data){
        let overviewA = [];
        let map = {};
        var i;
        for (i = 0; i < data.length; i++) {
            data[i].from = this.$helpers.extractTimeString(data[i].from);
            data[i].to = this.$helpers.extractTimeString(data[i].to);
            map[data[i].id] = data[i]; 
            let storeSalesTemplateItem = {
                id: data[i].id,
                from: data[i].from,
                to: data[i].to,
                amount: data[i].amount,
                currency: data[i].currency,
                weekDays: data[i].weekDays
               
            }
            
           
            overviewA.push(storeSalesTemplateItem);
        }
        this.storeSalesTemplateMap = map;
        this.storeSalesTemplates = overviewA;
    },
    deleteStoreSaleTemplate(id){
        
        let index = this.storeSalesTemplates.findIndex(storesalestemplate => storesalestemplate.id === id) 
        if (~index) {
             this.storeSalesTemplates.splice(index, 1);
        }
        delete this.storeSalesTemplateMap[id]
    },
    extractDate: function(str){
        if(!this.$helpers.isBlank(str)) {
            let split = str.split("T");
            return split[0];
        } else {
            return null;
        }
    },
    extractTimeString: function(str){
        if(!this.$helpers.isBlank(str)) {
            let split1 = str.split("T");
            let split2 = split1[1].split(":")
            return split2[0]+":"+split2[1];
        } else {
            return null;
        }
        
    },
    getMinuteDiff: function(from, to) {
        var diff =(to.getTime() - from.getTime()) / 1000;
        diff /= 60;
        return Math.round(diff);
    },
    getMinuteDiffAbs: function(from, to) {
        var diff =(to.getTime() - from.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    },
    generateUUID: function(){
        //https://jcward.com/UUID.js
        let lut = []; for (var i=0; i<256; i++) { lut[i] = (i<16?'0':'')+(i).toString(16); }
        let d0 = Math.random()*0xffffffff|0;
        let d1 = Math.random()*0xffffffff|0;
        let d2 = Math.random()*0xffffffff|0;
        let d3 = Math.random()*0xffffffff|0;
            return lut[d0&0xff]+lut[d0>>8&0xff]+lut[d0>>16&0xff]+lut[d0>>24&0xff]+'-'+
            lut[d1&0xff]+lut[d1>>8&0xff]+'-'+lut[d1>>16&0x0f|0x40]+lut[d1>>24&0xff]+'-'+
            lut[d2&0x3f|0x80]+lut[d2>>8&0xff]+'-'+lut[d2>>16&0xff]+lut[d2>>24&0xff]+
            lut[d3&0xff]+lut[d3>>8&0xff]+lut[d3>>16&0xff]+lut[d3>>24&0xff];
    },
    resetStoreSaleTemplateValues() {
        this.storeSalesTemplate = {
         
          from: null,
          to: null,
          amount: 0,
          currency: "EUR",
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          itemCount: 1,
          planned: true,
          description: ""
          
      };
    },
    hideModal (ref) {
        this.resetStoreSaleTemplateValues();
       
        this.error = false;
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  components: {
  },
  computed: {
   
  },
  watch: { 
   

    }

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>

</style>
